module.exports = __webpack_public_path__ + "img/flag-brazil.0bc833af.svg";